<template>
  <v-dialog v-model="csvDialog" scrollable max-width="350px">
    <v-card>
      <v-card-title>Shifts</v-card-title>
      <v-divider></v-divider>
      <v-card-text style="width: 350px">
        <v-menu
          ref="menuFrom"
          v-model="menuFrom"
          :close-on-content-click="false"
          :return-value.sync="dateFrom"
          transition="scale-transition"
          bottom
          right
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateFrom"
              label="From"
              readonly
              v-bind="attrs"
              v-on="on"
              class="date-field mt-5"
            ></v-text-field>
          </template>
          <v-date-picker v-model="dateFrom" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="menuFrom = false">
              Cancel
            </v-btn>
            <v-btn text color="primary" @click="$refs.menuFrom.save(dateFrom)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>

        <v-menu
          ref="menuTo"
          v-model="menuTo"
          :close-on-content-click="false"
          :return-value.sync="dateTo"
          transition="scale-transition"
          bottom
          right
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="dateTo"
              label="To"
              readonly
              v-bind="attrs"
              v-on="on"
              class="date-field"
            ></v-text-field>
          </template>
          <v-date-picker v-model="dateTo" no-title scrollable>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dateTo = false">
              Cancel
            </v-btn>
            <v-btn text color="primary" @click="$refs.menuTo.save(dateTo)">
              OK
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="download">
          Download CSV
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      dialogm1: "",
      dialog: false,
      menuFrom: false,
      menuTo: false,
      dateFrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateTo: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),

      userState: localStorage.getItem('userState'),

    };
  },

  computed: {
    ...mapState({
      unitIdsFilter: state => state.shifts.unitIdsFilter,
      staffFilter: state => state.shifts.staffFilter,
      clientsFilter: state => state.shifts.clientsFilter,
    }),

    csvDialog: {
      get() {
        return this.$store.state.shifts.csvDialog;
      },
      set(val) {
        this.$store.commit("shifts/SET_CSV_DIALOG", val);
      },
    },
  },

  watch: {
    // csvDialog (val) {
    //   if (val) {
    //     console.log("Units: "+this.unitIdsFilter)
    //     console.log("Staffs: "+this.staffFilter)
    //     console.log("Clients: "+this.clientsFilter)
    //   } else {
    //     console.log("closed");
    //   }
    // }
  },

  created () {
    
  },

  methods: {
    ...mapActions("shifts", ["downloadCSV"]),

    download() {
      const data = {
        StartDate: this.dateFrom,
        EndDate: this.dateTo,
        unitIds: this.unitIdsFilter.toString(),
        staffIds: this.staffFilter.toString(),
        clients: this.clientsFilter.toString(),
        userState: this.userState
      };
      Swal.fire({
          title: 'Download in Progress',
          text: 'Please wait while the CSV is being generated and processed. This may take a while.',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showCancelButton: false,
          showConfirmButton: false,
          didOpen: () => {
              Swal.showLoading();
          },
      });
      this.downloadCSV(data)
        .then((res) => {
           // Show the "Print in progress" modal
           
          if (res.data.success) {
            var FileSaver = require("file-saver");
            const blob = new Blob([res.data.data], { type: "text/csv" });
            FileSaver.saveAs(blob, res.data.filename);
            this.csvDialog = false;
            this.reset()
            // Close the modal when the printing process is complete
            Swal.close();
            return;
          } else {
            Swal.fire({
              text: res.data.message,
              icon: 'warning',
              allowOutsideClick: true,
              allowEscapeKey: true,
            });
          }
        })
        .catch((error) => {
          //console.log(error);
          Swal.fire('Error', error, 'error');
        });
    },

    reset() {
      this.dateFrom = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
      this.dateTo = new Date(
        Date.now() - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .substr(0, 10);
    },
  },
};
</script>

<style scoped>
.date-field >>> input {
  text-align: center !important;
}
</style>
